import { fixPublicUrlInNativeApp } from "../editorPage/utils/fixPublicUrlInNativeApp";

export const getPublicHashtagUrl = (tag: string, userId: string) => {
  const cleanedTag = tag.replace("#", "").trim();
  return fixPublicUrlInNativeApp(
    window.location.protocol + "//" + window.location.host + `/sharedBy/${userId}/tag/${cleanedTag.slice(1)}`,
  );
};
